export const pricingPlans = {
  "month": [
    {
      "price_id": "",
      "name": "Free",
      "price": 0,
      "description": "For your personal Waslat. Everything you do, in one single link",
      "features": [
        "Unlimited links",
        "Unlimited Social Icons"
      ],
      "type": "month"
    },
    {
      "price_id": "price_1OwWBOBHcb4lLL6SZJ5hBHK4",
      "name": "Premium",
      "description": "For content creators and businesses. Advanced analytics, automatic link apps and auto-embeds",
      "price": 9,
      "features": [
        "Advanced customization options",
        "Option to hide Waslat logo",
        "Conversion tracking",
        "Unlock more themes and fonts"
      ],
      "type": "month"
    }
  ],
  "year": [
    {
      "price_id": "",
      "name": "Free",
      "price": 0,
      "description": "For your personal Waslat. Everything you do, in one single link",
      "features": [
        "Unlimited links",
        "Unlimited Social Icons"
      ],
      "type": "year"
    },
    {
      "price_id": "price_1PJtNQBHcb4lLL6SHP0An965",
      "name": "Premium",
      "description": "For content creators and businesses. Advanced analytics, automatic link apps and auto-embeds",
      "price": 6,
      "features": [
        "Advanced customization options",
        "Option to hide Waslat logo",
        "Conversion tracking",
        "Unlock more themes and fonts"
      ],
      "type": "year"
    }
  ]
}